module.exports = __webpack_public_path__ + "img/stock5.63efd1ec.png";